export default class CommonViewComponent {

    /**
     * Invoked on both server and browser (except the first time for the browser)
     */
    _initElements() {
        if (this.elements.length) {
            this.elements.forEach((elementName) => {
                if (!this['$' + elementName]) {
                    this['$' + elementName] = $.create('div');
                }
                this['$' + elementName].setAttribute('data-role', elementName);
            });
        }
    }

    /**
     * Invoked only on browser just the first time
     */
    _loadElements() {
        if (this.elements.length) {
            this.elements.forEach((elementName) => {
                this['$' + elementName] = this.$container.findFirst('[data-role="' + elementName + '"]');
            });
            console.log(this.elements, this);
        }
    }

    /**
     * Invoked on both server and browser (even the first time for the browser)
     */
    init(properties) {
    }

    /**
     * Invoked only on browser just the first time
     */
    load() {
    }

    /**
     * Invoked on both server and browser (except the first time for the browser)
     */
    render(data) {
    }

    toHtmlString() {
        return this.$container.outerHTML;
    }
}
